import React from 'react'

const EliminarProducto = ({productoSelect, peticionDelete, setFuncion}) => {

	return(
		<div>
				<h4>¿Desea Realmente Eliminar?</h4>
					<hr />
					<div className="col text-center">

						<p>Producto: {productoSelect.nombre_producto}</p>
						<button
							onClick={peticionDelete}
							className="btn boton_estandar"
						>Eliminar
						</button>
						<button
							onClick={e => setFuncion('ver')}
							className="btn boton_estandar"
						>Cancelar
						</button>

					</div>
				</div>
	)
}

export default EliminarProducto